import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-property-status',
  templateUrl: './property-status.component.html',
  styleUrl: './property-status.component.css'
})
export class PropertyStatusComponent {
  @Input() rentaPropertyStatus :number =0; 
  @Input() statusDescription!:string;
 
  getStatusClass(): string {
    let ccsClass = '';
    switch(this.rentaPropertyStatus){
     case 1 :
      ccsClass = 'status-container-active';
      break;

      case 2 :
      ccsClass = 'status-container-inactive';
      break; 
      case 7 :
        ccsClass = 'status-container-pending';
        break; 
      default:
        ccsClass = 'status-container-active';
      break;
    }
    return ccsClass;
  }

  getBodyStatusClass(): string {
    let ccsClass = '';
    switch(this.rentaPropertyStatus){
     case 1 :
      ccsClass = 'status-body-active';
      break;

      case 2 :
      ccsClass = 'status-body-inactive';
      break;

      case 7 :
        ccsClass = 'status-body-pending';
        break;

      default:
        ccsClass = 'status-body-active';
      break;
    }
    return ccsClass;
  }

  getFontStatusClass(): string {
    let ccsClass = '';
    switch(this.rentaPropertyStatus){
     case 1 :
      ccsClass = 'status-font-active';
      break;

      case 2 :
      ccsClass = 'status-font-inactive';
      break;

      case 7 :
        ccsClass = 'status-font-pending';
        break;

      default:
        ccsClass = 'status-font-active';
      break;
    }
    return ccsClass;
  }
}
